import { Component, OnInit } from '@angular/core';
import { ContactData } from 'src/app/interfaces/contactData';
import { ContactsService } from 'src/app/service/contacts.service';
@Component({
  selector: 'app-contablecomp',
  templateUrl: './contablecomp.component.html',
  styleUrls: ['./contablecomp.component.scss']
})
export class ContablecompComponent implements OnInit {

  constructor(private contactsService: ContactsService) { }
  contact3: ContactData = {};
  contacts: ContactData[] = [];
  ngOnInit(): void {
    this.contactsService.getContacts().then(data => this.contacts = data);
  }

}
